import { Box, Divider } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { LazyBox } from "@outschool/ui-components-shared";
import { RecentlyViewListingCarousel } from "@outschool/ui-components-website";
import {
  CurvedGradientSection,
  Loading
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { MoreSameTeacherListingCarousel } from "./mobileBelowClassDetail/MoreSameTeacherListingCarousel";
import { ParentsAlsoLikeList } from "./mobileBelowClassDetail/ParentsAlsoLikedList";
import { RelatedCategories } from "./mobileBelowClassDetail/RelatedCategories";
import { TeacherSuggestList } from "./mobileBelowClassDetail/TeacherSuggestList";

type MobileBelowClassDetailProps = {
  otherListingsRef: React.MutableRefObject<null>;
  activity: ClassDetailsNoSectionsQuery["activity"];
  leader: NonNullable<ClassDetailsNoSectionsQuery["activity"]["leader"]>;
};
export const MobileBelowClassDetail = ({
  otherListingsRef,
  activity,
  leader
}: MobileBelowClassDetailProps) => {
  const CARROUSEL_ROW_NUM = 0;

  return (
    <CurvedGradientSection>
      <Box
        ref={otherListingsRef}
        sx={{
          minHeight: "500px",
          padding: "3rem 0"
        }}
      >
        <TeacherSuggestList activity={activity} leader={leader} />

        <MoreSameTeacherListingCarousel
          teacherName={leader.name || ""}
          carouselRowNum={CARROUSEL_ROW_NUM}
          activity={activity}
        />

        <RecentlyViewListingCarousel
          carouselRowNum={CARROUSEL_ROW_NUM}
          activity={activity}
        />

        <RelatedCategories activity={activity} />
        <Divider sx={{ borderColor: "gray100", marginTop: "2.4rem" }} />

        <LazyBox placeholder={<Loading />} rootMargin="150px 0px">
          <ParentsAlsoLikeList activity={activity} />
        </LazyBox>
      </Box>
    </CurvedGradientSection>
  );
};
